window.adBundleLoadTime = Date.now();
